// 访客申请配置
const visitorConfigJurisdiction = [
  { id: "007001001", label: "修改", children: [] }
];

// 访客机管理
const visitorDeviceJurisdiction = [
  { id: "007002001", label: "添加访客机", children: [] },
  { id: "007002002", label: "删除访客机", children: [] },
  { id: "007002003", label: "修改访客机", children: [] }
];

// 刷卡记录
const payByCardRecordJurisdiction = [
  { id: "007002001", label: "导出刷卡记录", children: [] }
];

// 智慧访客
const appointmentServiceJurisdictionChildren = [
  {
    id: "007007000",
    label: "概览",
    routerName: "visitor-over-view",
    children: []
  },
  {
    id: "007001000",
    label: "访客申请配置",
    routerName: "visitor-config",
    children: visitorConfigJurisdiction
  },
  {
    id: "007002000",
    label: "访客机管理",
    routerName: "visitor-device-manage",
    children: visitorDeviceJurisdiction
  },
  {
    id: "007003000",
    label: "登记记录",
    routerName: "visitor-register",
    children: []
  },
  {
    id: "007004000",
    label: "预约记录",
    routerName: "appointment-record",
    children: []
  },
  {
    id: "007005000",
    label: "出入记录",
    routerName: "credit-card-record",
    children: payByCardRecordJurisdiction
  },
  {
    id: "007006000",
    label: "操作日志",
    routerName: "visitor-service-log",
    children: []
  }
];

const appointmentServiceJurisdiction = {
  id: "007",
  label: "智慧访客",
  children: appointmentServiceJurisdictionChildren
};

export { appointmentServiceJurisdiction };



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/appointmentServiceJurisdiction.js